export const useCurrency = () => {

  const toCurrency = (value?: number | string) => {
    if (!value) {
      return value
    }
    const formatter = new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: 'CZK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatter.format(Number(value))
  }

  return {
    toCurrency
  }
}
